<template>
  <div>
    <rest-list :payload="fetchEndpoint" ref="rest-list">
      <template>
        <rest-list-column
          prop="sync_task_id"
          :title="$t('Automations_RunHistory_SyncTaskId')"
          :sortable="false"
          :width="120"
        >
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.sync_task_id"
              :to="syncTaskRoute(scope.row)"
            >
              {{ scope.row.sync_task_id }}
            </router-link>
            <template v-else>-</template>
          </template>
        </rest-list-column>

        <rest-list-column-date
          prop="create_time"
          :title="$t('TaskHistoryList_Field_CreateTime')"
          :width="200"
        />

        <rest-list-column-date
          prop="finish_time"
          :title="$t('Automations_RunHistory_CompletionDate')"
          :width="200"
        />

        <rest-list-column-enum
          prop="status"
          :title="$t('TaskHistoryList_Field_Status')"
          :enum="statusLabel"
          :min-width="150"
        />

        <rest-list-column
          v-if="!isDbSource"
          prop="file_name"
          :sortable="false"
          :filterable="false"
          :title="$t('Automations_RunHistory_FileName')"
          :min-width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.file_name || '-' }}
          </template>
        </rest-list-column>

        <rest-list-column
          prop="statsTotal"
          :sortable="false"
          :filterable="false"
          :title="$t('Automations_RunHistory_Stats_Total')"
          :width="100"
        >
          <template slot-scope="scope">
            {{ formatStat(scope.row, 'total') }}
          </template>
        </rest-list-column>

        <rest-list-column
          prop="statsImported"
          :sortable="false"
          :filterable="false"
          :title="$t('Automations_RunHistory_Stats_Success')"
          :width="100"
        >
          <template slot-scope="scope">
            {{ formatStat(scope.row, 'imported') }}
          </template>
        </rest-list-column>

        <rest-list-column
          prop="statsFailed"
          :sortable="false"
          :filterable="false"
          :title="$t('Automations_RunHistory_Stats_Error')"
          :width="100"
        >
          <template slot-scope="scope">
            {{ formatStat(scope.row, 'failed') }}
          </template>
        </rest-list-column>

        <rest-list-column
          prop="statsWarnings"
          :sortable="false"
          :filterable="false"
          :title="$t('Automations_RunHistory_Stats_Warning')"
          :width="100"
        >
          <template slot-scope="scope">
            {{ formatStat(scope.row, 'warnings') }}
          </template>
        </rest-list-column>

        <rest-list-column-actions>
          <template slot-scope="scope">
            <rest-list-action-view :route="rowViewRoute(scope.row)" />
          </template>
        </rest-list-column-actions>
      </template>
    </rest-list>
  </div>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionView from '@/common/components/rest/RestListActionView'
import {
  taskIdentifierLabel as identifierLabel,
  taskStatusLabel as statusLabel
} from '@/modules/tasks/enum/TaskRecordEnums'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'ImportRunHistoryTasks',

  inject: ['automationData'],

  components: {
    RestList,
    RestListColumn,
    RestListColumnEnum,
    RestListColumnDate,
    RestListColumnActions,
    RestListActionView
  },

  data() {
    return {
      identifierLabel,
      statusLabel
    }
  },

  computed: {
    automationId() {
      return this.$route.query.id
    },

    automation() {
      return this.automationData()
    },

    isDbSource() {
      return (
        this.automation &&
        this.automation.source &&
        this.automation.source.type === 'db'
      )
    },

    fetchEndpoint() {
      const expand = this.isDbSource
        ? 'sync_task_id,result'
        : 'sync_task_id,result,file_name'

      return projectEndpoint({
        method: 'get',
        url: 'task-histories',
        params: {
          sort: '-id',
          import_automation_id: this.automationId,
          identifier: 'profile_import,event_import,profile_attribute_import',
          expand
        }
      })
    }
  },

  methods: {
    rowViewRoute(row) {
      return projectRoute({
        name: 'TaskHistoryView',
        query: { id: row.id }
      })
    },

    syncTaskRoute(row) {
      return projectRoute({
        name: 'TaskHistoryView',
        query: { id: row.sync_task_id }
      })
    },

    formatStat(row, key) {
      const stats = row.result && row.result.stats
      if (!stats) return '-'
      const val = stats[key]
      return val !== null && val !== undefined
        ? Number(val).toLocaleString()
        : '-'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/automations/components/ImportRunHistoryTasks.vue